import React, { useState, useCallback, useEffect } from 'react';
import { withStyles, makeStyles } from '@material-ui/core';
import useEmblaCarousel from 'embla-carousel-react-latest';
import Autoplay from 'embla-carousel-autoplay';
import arrowPrev from '../../asset/img/autoplay_prev.svg';
import arrowNext from '../../asset/img/autoplay_next.svg';
import buttonPlay from '../../asset/img/btn_play.svg';
import buttonStop from '../../asset/img/btn_stop.svg';

const styles = (theme) => ({
  root: {
    position: 'relative',
    maxWidth: '100%',
    width: '100%',
    padding: '0rem 0.625rem',
    display: 'flex',
    // flexDirection: 'row',
    alignItems: 'center',
  },
  embla: {
    overflow: 'hidden',
  },
  embla__container: {
    display: 'flex',
    // alignItems: "center",
    // justifyContent: "center"
  },
  list: {
    display: 'flex',
    alignItems: 'stretch',
    width: '100%',
    'user-select': 'none',
    '-webkit-touch-callout': 'none',
    '-khtml-user-select': 'none',
    '-webkit-tap-highlight-color': 'transparent',
  },
  dots: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    margin: '1rem 0rem',
  },
  dot: {
    width: '0.5rem',
    height: '0.5rem',
    borderRadius: '0.5rem',
    margin: '0rem 0.2813rem',
    backgroundColor: '#666',
    // opacity: '0.2',
    transition: 'all, .5s, ease-in-out',
    padding: '0',
    border: 'none',
  },
  dotActive: {
    width: '18px',
    height: '6px',
    background: '#000',
    border: '999px',
    opacity: '1',
  },
  dotSide: {
    background: '#666',
    transform: 'scale(.75)',
    // opacity: ".2",
  },
  dotSideSide: {
    background: '#666',
    transform: 'scale(.5)',
    // opacity: ".2",
  },
  blur: {
    width: '2.125rem',
    height: '2.625rem',
    position: 'absolute',
    display: 'block',
    top: '50%',
    padding: '0rem',
    overflow: 'auto',
    textIndent: '-9999em',
    border: 'none',
    background: 'none',
    '-webkit-transform': 'translate3d(0,-50%,0)',
    zIndex: '12',
  },
  blurPrev: {
    left: '0rem',
    backgroundImage:
      '-webkit-linear-gradient(to left, rgba(255,255,255,0), rgba(245,245,245,1.0))',
    backgroundImage:
      'linear-gradient(to left, rgba(255,255,255,0), rgba(245,245,245,1.0))',
  },
  blurNext: {
    right: '0rem',
    backgroundImage:
      '-webkit-linear-gradient(to right, rgba(255,255,255,0), rgba(245,245,245,1.0))',
    backgroundImage:
      'linear-gradient(to right, rgba(255,255,255,0), rgba(245,245,245,1.0))',
  },
  blurPrevDark: {
    left: '0rem',
    backgroundImage:
      '-webkit-linear-gradient(to left, rgba(36,36,36,0), rgba(0,0,0,1.0))',
    backgroundImage: 'linear-gradient(to left, rgba(36,36,36,0), rgba(0,0,0,1.0))',
  },
  blurNextDark: {
    right: '0rem',
    backgroundImage:
      '-webkit-linear-gradient(to right, rgba(36,36,36,0), rgba(0,0,0,1.0))',
    backgroundImage: 'linear-gradient(to right, rgba(36,36,36,0), rgba(0,0,0,1.0))',
  },
  autoPlaybutton: {
    // position: 'absolute',
    // top: '50%',
    // transform: 'translateY(-50%)',
    right: '50px',
    zIndex: '1000',
  },
  swipe: {
    width: '0.25rem',
    height: '0.5rem',
    display: 'block',
    padding: '0rem',
    // overflow: 'hidden',
    textIndent: '-9999em',
    border: 'none',
    zIndex: '12',
    backgroundColor: '#F0ECE4',
    padding: '0.625rem',
  },
  prev: {
    right: '4rem',
    background: `url(${arrowPrev}) no-repeat center center`,
    // '&:hover': {
    //   backgroundPosition: 'left 2.625rem',
    // },
  },
  next: {
    right: '0rem',
    background: `url(${arrowNext}) no-repeat center center`,
    // '&:hover': {
    //   backgroundPosition: 'right 2.625rem',
    // },
  },
  prevNextArrow: {
    color: '#000',
    fontSize: theme.font.size12,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    background: '#f0ece4',
    height: '1.5rem',
    borderRadius: '1.5rem',
    marginLeft: '0.313rem',
    width: '100%',
    maxWidth: '5.625rem',
  },
  prevNextArrowTI: {
    position: 'absolute',
    left: '50%',
    bottom: '-40px',
    position: 'absolute',
    transform: 'translateX(-50%)',
    background: '#f6f6f6',
  },
  buttonPlay: {
    width: '1.5rem',
    height: '1.5rem',
    display: 'block',
    background: `url(${buttonPlay}) no-repeat center center`,
    border: 'none',
  },
  buttonStop: {
    width: '1.5rem',
    height: '1.5rem',
    display: 'block',
    background: `url(${buttonStop}) no-repeat center center`,
    border: 'none',
  },
  slideIndex: {
    fontWeight: 'bold',
  },
  IBslideIndex: {
    width: '2.5rem',
    textAlign: 'center',
  },
});

function CarouselEmbla({ component: Component, ...props }) {
  const {
    classes,
    children,
    data,
    parentFunc,
    parentVal,
    indicator = true,
    arrowsIB = false,
    arrowsTI = false,
    blur = false,
    ariaLabel = null,
    options = null,
    autoplay = false,
    itemCount = null,
  } = props;

  const [slide, setSlide] = useState(0);
  const [canScrollPrev, setCanScrollPrev] = useState(false);
  const [canScrollNext, setCanScrollNext] = useState(false);

  const [emblaRef, emblaApi] = useEmblaCarousel(
    options
      ? options
      : { align: 'start', dragFree: false, containScroll: true, loop: true },
    autoplay ? [Autoplay()] : []
  );

  const [isPlaying, setIsPlaying] = useState(false);

  const toggleAutoplay = useCallback(() => {
    const autoplay = emblaApi?.plugins()?.autoplay;
    if (!autoplay) return;

    const playOrStop = autoplay.isPlaying() ? autoplay.stop : autoplay.play;
    playOrStop();
  }, [emblaApi]);

  useEffect(() => {
    const autoplay = emblaApi?.plugins()?.autoplay;
    if (!autoplay) return;

    setIsPlaying(autoplay.isPlaying());
    emblaApi
      .on('autoplay:play', () => setIsPlaying(true))
      .on('autoplay:stop', () => setIsPlaying(false))
      .on('reInit', () => setIsPlaying(autoplay.isPlaying()));
  }, [emblaApi]);

  const onScrollPrev = useCallback(() => {
    emblaApi && emblaApi.scrollPrev();
  }, [emblaApi]);
  const onScrollNext = useCallback(() => {
    emblaApi && emblaApi.scrollNext();
  }, [emblaApi]);
  const gotoIndex = useCallback(
    (index, jump = false) => {
      emblaApi && emblaApi.scrollTo(index, jump);
    },
    [emblaApi]
  );

  const [childComponent, setChildComponent] = useState(null);

  const maxShowLen = 6;
  const minShowLen = 2;

  const setScrollStatus = () => {
    if (emblaApi) {
      setSlide(emblaApi.selectedScrollSnap());
      // console.log(`[setScrollStatus] slidesInView : ${emblaApi.slidesInView()}`)
      // console.log(`[setScrollStatus] selectedScrollSnap : ${emblaApi.selectedScrollSnap()}`)
      // setSlide(emblaApi.slidesInView());
      setCanScrollPrev(emblaApi.canScrollPrev());
      setCanScrollNext(emblaApi.canScrollNext());
    }
  };

  useEffect(() => {
    if (emblaApi) {
      setCanScrollPrev(emblaApi.canScrollPrev());
      setCanScrollNext(emblaApi.canScrollNext());

      emblaApi.on('select', () => {
        setScrollStatus();
      });
      emblaApi.on('resize', () => {
        setScrollStatus();
      });
      emblaApi.on('pointerUp', () => {
        console.log('pointer up');
      });
      emblaApi.on('pointerDown', () => {
        console.log('pointer down');
      });
    }

    if (Component) {
      setChildComponent(
        <Component
          ref={emblaRef}
          data={data}
          parentFunc={parentFunc}
          parentVal={parentVal}
          goNext={() => onScrollNext()}
          goPrev={() => onScrollPrev()}
          gotoIndex={(index) => gotoIndex(index)}
          canScrollNext={canScrollNext}
          canScrollPrev={canScrollPrev}
          activeSlide={slide}
        />
      );
    } else {
      setChildComponent(children);
    }
    //remove below line due to https://github.com/davidcetinkaya/embla-carousel-react/issues/13
    //return () => embla && embla.destroy();
  }, [emblaApi, parentVal, data, canScrollNext, gotoIndex, slide]);

  const renderDots = useCallback(() => {
    if (emblaApi) {
      const slideLength = itemCount !== null ? itemCount : emblaApi.slideNodes().length;
      const halfShowLen = maxShowLen / 2;

      // console.log(`slideLength: ${slideLength}`)
      // console.log(`============================================================`)
      // console.log(`total:${slideLength}, maxShow:${maxShowLen}, halfShow:${halfShowLen}, slideIndex:${slide}`)

      const getMaxMinIndex = (slideIndex) => {
        const tailLeft = slideIndex + halfShowLen - slideLength;
        let minIndex = slideIndex - halfShowLen + 1;
        const headLeft = halfShowLen - (slideIndex + 1);
        let maxIndex = slideIndex + halfShowLen + 1;

        if (headLeft < 0 && tailLeft < 0) {
          maxIndex = slideIndex + halfShowLen;
          minIndex = slideIndex - halfShowLen;
        } else {
          if (headLeft >= 0) {
            maxIndex = slideIndex + halfShowLen + headLeft + 1;
          }
          if (tailLeft >= 0) {
            minIndex = slideIndex - (halfShowLen + tailLeft + 1);
          }
        }

        // console.log(`[maxIndex] headLeft:${headLeft}, minIndex:${minIndex}, maxIndex:${maxIndex}, tailLeft:${tailLeft} `)
        return { minIndex, maxIndex };
      };
      const itemList =
        itemCount !== null
          ? Array.from({ length: itemCount })
          : emblaApi.scrollSnapList();
      return (
        <div
          className={classes.dots}
          role={'text'}
          tabIndex={0}
          aria-label={`${slide + 1}번째 슬라이드 선택됨, ${slide + 1} / ${
            itemList.length
          }`}
        >
          {/* <div className={classes.dots}> */}
          {slideLength < maxShowLen
            ? itemList.map((snap, index) => {
                return (
                  <button
                    key={index}
                    active={index === slide ? 'true' : 'false'}
                    // onClick={() => emblaApi.scrollTo(index)}
                    // hidden={index < slide - 3 || index > slide + 3}
                    // role={"button"}
                    className={
                      index === slide
                        ? [classes.dot, classes.dotActive].join(' ')
                        : [classes.dot, classes.dotSide].join(' ')
                    }
                    // aria-label={`${index === slide ? "선택됨," : ""} ${ariaLabel ? ariaLabel : ""} ${index + 1}번째 슬라이드 보기, ${index + 1} / ${emblaApi.scrollSnapList().length}`}
                  />
                );
              })
            : slideLength === maxShowLen
            ? itemList.map((snap, index) => {
                return (
                  <button
                    key={index}
                    active={index === slide ? 'true' : 'false'}
                    // onClick={() => emblaApi.scrollTo(index)}
                    // hidden={index < minIndex || index > maxIndex}
                    // role={"button"}
                    className={
                      index === slide
                        ? [classes.dot, classes.dotActive].join(' ')
                        : index === 0 || index === itemList.length - 1
                        ? [classes.dot, classes.dotSideSide].join(' ')
                        : [classes.dot, classes.dotSide].join(' ')
                    }
                    // aria-label={`${index === slide ? "선택됨," : ""} ${ariaLabel ? ariaLabel : ""} ${index + 1}번째 슬라이드 보기, ${index + 1} / ${emblaApi.scrollSnapList().length}`}
                  />
                );
              })
            : itemList.map((snap, index) => {
                let { minIndex, maxIndex } = getMaxMinIndex(slide);
                console.log(
                  `total(${itemList.length}),cur(${slide}),minIndex(${minIndex}),maxIndex(${maxIndex})`
                );
                return (
                  <p
                    key={index}
                    active={index === slide ? 'true' : 'false'}
                    // onClick={() => emblaApi.scrollTo(index)}
                    // role={"button"}
                    hidden={index < minIndex || index > maxIndex}
                    className={
                      index === slide
                        ? [classes.dot, classes.dotActive].join(' ')
                        : index === minIndex ||
                          index === maxIndex ||
                          index === 0 ||
                          index === itemList.length - 1
                        ? [classes.dot, classes.dotSideSide].join(' ')
                        : [classes.dot, classes.dotSide].join(' ')
                      // : index === slide + 2 || index === slide - 2
                      // ? [classes.dot, classes.dotSideSide].join(" ")
                      // : undefined
                    }
                    // aria-label={`${index === slide ? "선택됨," : ""} ${ariaLabel ? ariaLabel : ""} ${index + 1}번째 슬라이드 보기, ${index + 1} / ${emblaApi.scrollSnapList().length}`}
                  />
                );
              })}
        </div>
      );
    }
    return null;
  }, [emblaApi, slide]);

  const slideLength = useCallback(() => {
    if (emblaApi) {
      return emblaApi.slideNodes().length;
    }
    return null;
  }, [emblaApi]);

  return (
    <div
      className={classes.root}
      onTouchMove={(e) => {
        console.log(`[CarouselEmbla] onTouchMove`);
        e.stopPropagation();
      }}
    >
      {childComponent && (
        <div className={classes.embla} ref={emblaRef}>
          <div className={classes.embla__container}>{childComponent}</div>
        </div>
      )}

      {/* Autoplay 재생/정지 버튼 */}
      {autoplay && (
        <div className={classes.autoPlaybutton}>
          <button
            type="button"
            onClick={toggleAutoplay}
            className={isPlaying ? classes.buttonStop : classes.buttonPlay}
          >
            {/* {isPlaying ? (
              <span className={classes.buttonStop}>정지</span>
            ) : (
              <span className={classes.buttonPlay}>재생</span>
            )} */}
          </button>
        </div>
      )}

      {/* Pagination 좌/우 버튼 */}
      {/* {canScrollPrev ? (
        arrows ? (
          <button
            type="button"
            className={[classes.swipe, classes.prev].join(' ')}
            onClick={onScrollPrev}
          >
            이전버튼
          </button>
        ) : (
          blur && <div className={[classes.blur, classes.blurPrev].join(' ')} />
        )
      ) : null}
      {canScrollNext ? (
        arrows ? (
          <button
            type="button"
            className={[classes.swipe, classes.next].join(' ')}
            onClick={onScrollNext}
          >
            다음버튼
          </button>
        ) : (
          blur && <div className={[classes.blur, classes.blurNext].join(' ')} />
        )
      ) : null} */}
      {/* IB 커스텀마이징 */}
      {arrowsIB && (
        <div className={classes.prevNextArrow}>
          <button
            type="button"
            className={[classes.swipe, classes.prev].join(' ')}
            onClick={onScrollPrev}
          >
            이전버튼
          </button>
          <div className={classes.IBslideIndex}>
            <span className={classes.slideIndex}>{slide + 1}</span> / {slideLength()}
          </div>
          <button
            type="button"
            className={[classes.swipe, classes.next].join(' ')}
            onClick={onScrollNext}
          >
            다음버튼
          </button>
        </div>
      )}

      {/* TICard 커스텀마이징 */}
      {arrowsTI && (
        <div className={[classes.prevNextArrow, classes.prevNextArrowTI].join(' ')}>
          <button
            type="button"
            className={[classes.swipe, classes.prev].join(' ')}
            onClick={onScrollPrev}
          >
            이전버튼
          </button>
          <div className={classes.IBslideIndex}>
            <span className={classes.slideIndex}>{slide + 1}</span> / {slideLength()}
          </div>
          <button
            type="button"
            className={[classes.swipe, classes.next].join(' ')}
            onClick={onScrollNext}
          >
            다음버튼
          </button>
        </div>
      )}

      {/* Pagination Dot 버튼 */}
      {/* {indicator && (canScrollPrev || canScrollNext) && renderDots()} */}
      {indicator &&
        (itemCount != null
          ? itemCount >= minShowLen && renderDots()
          : (canScrollPrev || canScrollNext) && renderDots())}
    </div>
  );
}
export default withStyles(styles)(CarouselEmbla);
